import styled from '@emotion/styled'

import { Container } from '@/components/Container'
import { BodyM } from '@/components/Typography'

interface Props {
  text?: string
}

const BlogContentStyles = styled(BodyM)`
  h2,
  h3,
  h4 {
    margin: 0 0 1rem;
    color: rgba(var(--colors-text-dark-high));
    display: block;
    font-weight: 700;
  }

  h2 {
    font-size: 1.25rem;
  }

  h3,
  h4 {
    font-size: 1rem;
  }

  blockquote {
    margin: 1rem 0;
    padding: 1rem;
    border-left: 5px solid rgba(var(--colors-accent));
  }

  table {
    margin: 1rem auto;
  }

  th,
  td {
    border: 1px solid rgba(var(--colors-text-dark-low)) !important;
    padding: 0.25rem 0.5rem;
  }

  th,
  thead td {
    border-radius: 0 !important;
    font-weight: bold;
    color: rgba(var(--colors-white)) !important;
    background: rgba(var(--colors-accent)) !important;
    border-color: transparent transparent rgba(var(--colors-accent)) transparent !important;
  }

  th:first-of-type,
  thead td:first-of-type {
    border-top-left-radius: var(--theme-border-radius) !important;
  }

  th:last-of-type,
  thead td:last-of-type {
    border-top-right-radius: var(--theme-border-radius) !important;
  }

  ul,
  ol {
    margin-bottom: 1rem;
  }

  li {
    display: block;
    counter-increment: list-item-number;
  }

  li:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  li:after,
  li:before {
    content: '';
    display: block;
    clear: both;
  }

  ul li:before {
    float: left;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 3px;
    margin: 0.5rem 1.5rem 1.25rem 0.5rem;
    background-color: rgba(var(--theme-primary-300));
  }

  ol li:before {
    content: counter(list-item-number) '  ';
    float: left;
    margin-right: 1rem;
    background-color: rgba(var(--theme-primary-300), 0.2);
    border-radius: 3px;
    flex: 1 0 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    left: -1.5rem;
    display: inline-flex;
    font-size: 0.875rem;
    justify-content: center;
    align-items: center;
  }

  ol li + li {
    margin-top: 0.75rem;
  }
`

const BlogContentBlock = ({ text }: Props) => (
  <Container spaceIn="s">
    <BlogContentStyles tag="div" dark="medium" html={text} />
  </Container>
)

export default BlogContentBlock
